<template>
  <div class="my-3">
<!-- <div>Detail view include page </div> -->

    <DxDataGrid
      
      :columns="columns"  
      :data-source="dataStore" 
      :ref="gridRefName"
      :show-borders="true"
      :showRowLines="true"
      :hover-state-enabled="true"
      :allow-column-resizing="true"
      :column-min-width="50"
      :column-auto-width="true"
      :remote-operations="true"
      @cell-prepared="onCellPrepared"
      @hover-changed="onCellHoverChanged">
 
    <DxScrolling column-rendering-mode="virtual"/>
     <DxPaging :page-size="10"/>
     
      
      <DxPager
        :visible="true"
        :allowed-page-sizes="pageSizes"
        display-mode="full"
        :show-page-size-selector="false"
        :show-info="true"
        :show-navigation-buttons="true"
      />
      
      

      <DxColumnChooser :enabled="true"/>
      <DxFilterRow
          :visible="true"

      />
      
      <DxToolbar>
     
        <DxItem location="after">
          <DxButton
            icon="refresh"
            @click="refreshData"
          />
        </DxItem>

        <DxItem location="after">
            <DxButton
              icon="link"
              @click="showQuickLink"
            />
        </DxItem>
  
        <DxItem location="after">
          <DxButton
            icon="plus"          
            @click="showQuickCreate"
          />
        </DxItem>

        <DxItem
            name="columnChooserButton"
          />
    
      </DxToolbar>

    </DxDataGrid>

  <!-- pop up for quick create -->
   <DxPopup
      v-model:visible="createPopupVisible"
      :drag-enabled="true"
      :show-close-button="true"
      :close-on-outside-click="false"
      :show-title="true"
      :resizeEnabled="true"
      :title="creatTitle"
    >
      
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="saveButtonOptions"
      />
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="closeButtonOptions"
      />
      
     
      <BsEditForm  :routeDef="this.routeDef" :modelData="modelData" ref="quickformRenderer" />
    
  </DxPopup>


  <QuickLink  :routeDef="this.routeDef" :parentRoute="parentRoute" :parentId="parentId" :relationDef="this.relationDef" ref="quick-link" ></QuickLink>

  </div>
</template>
<script>

import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging
  
} from "devextreme-vue/data-grid";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
  DxLabel,
} from 'devextreme-vue/form';
import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup';
import { DxTextArea } from "devextreme-vue/text-area";
import {  getHeaders, getQuickCreateDef } from "@include/utils/GridUtils.js";
import { employees, states, products } from "@/Utils/Utils.js";
import CustomStore from "devextreme/data/custom_store";


import { DxButton } from 'devextreme-vue/button';
import { DxSelectBox } from 'devextreme-vue/select-box';
import BsEdit from "@/Base/BsEdit.vue";
import QuickLink from '@include/forms/BsLinkView.vue';
import BsEditForm from '@include/forms/BsEditForm.vue';

// this instance
var ins = Object();

export default {
  props: {
    parentRoute:String,
    routeDef: String,
    parentId:String,
    relationDef: {
                type: Object,
                default: () => ({})
            },
  },
  components: {
    BsEdit,
    QuickLink,
    DxItem,
    DxDataGrid,
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    employees,
    products,
    DxPopup,
    DxForm,
    DxTextArea,
    DxToolbarItem,
    DxButton,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxSelectBox,
    DxSelection,
    DxPosition,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxFilterRow,
    BsEditForm,

    DxScrolling,
    DxPager,
    DxPaging,

  },
  data: function () {
    return {  
      /* Common vars  */
      headersDef: [],
     // dataStore: getGridData("/"+this.parentRoute+"/relatedata",{id:this.parentId,relateName:this.relationDef.name}),
      columns: [],
      dataStore:[],
      
      /* for detail Panel */
      test1:"apple",              
      createDef: [],  
      modelData :{},
      positionOf: '',      
      /* for detail Quick Create */
      pageSizes: ['all'],
      createPopupVisible: false,
      creatTitle: "Quick Create",
      labelLocation: "top",
      gridRefName: 'dataGrid',
      form: this.$inertia.form(),
      formData: {},
      relationObj: {
        module_id :this.parentId,
        module_route: this.parentRoute,
        relate_id:"",
        relationDef:this.relationDef,
        relationData: this.formData,
      },
      saveButtonOptions: {
        icon: 'save',
        text: 'Save',
        onClick: this.onSaveRelation,
      },
      closeButtonOptions: {
        text: 'Close',
        onClick: () => {         
            this.createPopupVisible= false;          
        },
      },
      /* for detail Attatch Relation */     
      selectedIds:[],
      popupLinkVisible :false,       
      saveLinkButtonOptions: {
        icon: 'save',
        text: 'Save',
        onClick: this.onLinkRelation,
      },
      closeLinkButtonOptions: {
        text: 'Close',
        onClick: () => {
        this.popupLinkVisible = false;
        },
      },


    };
  },
  mounted() {

    ins = this;
    console.log("RouteDef",this.routeDef);

    /* load header for list */
    getHeaders(this.routeDef).then((response) => {
        //  let arry = [{dataField: "action", caption: "Action", name: "action"}]
        //  let mergerdArray = response.data.concat(arry)

        // this.columns = mergerdArray;



         var columnDefs1 = [
       
         {
           type: 'buttons',
           buttons: [{
             icon: 'edit',
              onClick: function (e) {
                
                ins.onQuickEdit(e.row.data);
              }
           },
           {
             icon:'trash',
             
           }]
         }
      ];
     
   
   
     // columnDefs1 = columnDefs1.concat(response.data);
      columnDefs1 = response.data.concat(columnDefs1);; 
      this.columns = columnDefs1;
      
    })
    .catch((error) => {  

    });
    /* def for quickcreate */
    /* getQuickCreateDef(this.routeDef).then((response) => {
         
        this.items = response.data.results;
    })
    .catch((error) => {  

    }); */

    
       
  },
   
  methods: {
    /* for detail panel */
    refreshData(){
      /* let ab ="quick-link";
      this.$refs[ab].showQuickLink(); */
      this.$refs[this.gridRefName].instance.refresh();


    }, 
    showQuickCreate() {
      var data = {};
      this.creatTitle = "Quick Create";
      this.$refs["quickformRenderer"].setData(data,"create");
      this.createPopupVisible = true;      
    },
    onQuickEdit(data)
    {
     
      this.creatTitle = "Quick Edit";
      this.$refs["quickformRenderer"].setData(data,"edit");
     
      this.createPopupVisible = true;
    },
    showQuickLink() {
      //this.popupLinkVisible = true;
      let ab ="quick-link";
      this.$refs[ab].showQuickLink();
    },
    /* for create relation */
    onSaveRelation()
    {

        if(this.relationDef.relation == "OneToMany")
        {
            this.formData[this.relationDef.dataField] = this.parentId;
        }
        
        this.relationObj.relationData = this.$refs.quickformRenderer.formData;

        // cneck mode create or edit
        if(this.$refs.quickformRenderer.mode == "create")
        {
            this.$inertia.post('/'+ this.parentRoute +'/addrelate', this.relationObj);
        }
        if(this.$refs.quickformRenderer.mode == "edit")
        {
          this.$inertia.post('/'+ this.parentRoute +'/updateRelate', this.relationObj);
        }        
              
        this.createPopupVisible = false;
        this.refreshData();

    },
    /* for link relation */
    onSelectionChanged({ selectedRowsData })
    {
      //SelectedRowKeys
      this.selectedIds = selectedRowsData;
    },

    getQuickDef(){
     getQuickCreateDef(this.routeDef).then((response) => {
            
            this.createDef = response.data.results;
        })
        .catch((error) => {  

        });

    },
    onCellPrepared(e) {
      if (e.columnIndex == 1 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        elem.style.setProperty("color", "blue");
      }
    },
    onCellHoverChanged(e) {
      if (e.columnIndex == 1 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        if (e.eventType === "mouseover") {
          e.cellElement.style.color = "blue";
        } else {
          e.cellElement.style.color = "";
        }

        elem.style.setProperty("color", "green");
      }
    },

    getGridDataSource(mRoute,params={}){
      return new CustomStore({
        key: "id",
        load: function (loadOptions) {
          var parameters = {};
          if (loadOptions.sort) {
            parameters.order_column = loadOptions.sort[0].selector;
            if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
          }
          parameters.filter = JSON.stringify(loadOptions.filter);
          parameters.skip = loadOptions.skip;
          parameters.take = loadOptions.take;
          parameters.page = (parameters.skip + parameters.take) / parameters.take;
          let merged = {...parameters, ...params};
          var config = {
            params: merged,
          };
          let listurl =  mRoute; 
         
          return axios
            .get(listurl, config)
            .then((response) => {
              return {
                data: response.data.results.data,
                totalCount: response.data.results.total,
              };
            })
            .catch(() => {
              throw "Data Loading Error";
            });
        },
        
    });

    

    }
        
   
  },
  created: function () {
     this.dataStore = this.getGridDataSource("/"+this.parentRoute+"/relatedata",{id:this.parentId,relateName:this.relationDef.name});

  },
  computed: {
     
        dataGrid: function() {
            return this.$refs[this.gridRefName].instance;
        },
        quickDef: function(){

 
       
       }
        
        
        },


};
</script>
<style scoped>
#data-grid-demo {
  min-height: 700px;
}

</style>